import {
  MultiSelect as MantineMultiSelect,
  MultiSelectProps,
} from '@mantine/core';

export type IMultiSelectProps = MultiSelectProps;

/** @registry Design-layer pass-through over Mantine MultiSelect; import this instead of @mantine/core MultiSelect outside src/design. Extend here when MultiSelect needs house behavior. */
export const MultiSelect = MantineMultiSelect;
